/**
 * Alert-type display name in the active UI language.
 *
 * The names live in the shared bundle (`shared.alert_types.*`), which is the
 * SAME file the backend sends push notifications from — so the phone
 * notification, the alerts table and the detail modal can never drift apart.
 *
 * Types the bundle doesn't know fall through unchanged. That is not a
 * fallback, it is the contract: a customer's free-text concept alert has no
 * translation because its name IS its type, typed by them in their own
 * language on /alert-config.
 */
import type { TFunction } from "i18next";

export function alertTypeLabel(type: string, t: TFunction): string {
  return t(`shared.alert_types.${type}`, { defaultValue: type });
}
